export default __webpack_public_path__ + "571c96f3249de49e33b15a38517c6a50.svg";